import { Box, useTheme } from "@mui/material";
import { useUser } from "hooks";
import React from "react";
import { ThemeOption } from "types";

interface InputUpdate {
	valueTitle: string;
	handleGalleryTitleChange: (
		event: React.ChangeEvent<HTMLInputElement>,
	) => void;
	handleGalleryTitleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
	selectAllInlineText: (event: React.MouseEvent<HTMLInputElement>) => void;
	refInput?: React.RefObject<HTMLInputElement>;
}

const InputUpdate = ({
	valueTitle,
	handleGalleryTitleChange,
	handleGalleryTitleBlur,
	selectAllInlineText,
	refInput,
}: InputUpdate) => {
	const { mode } = useUser();
	const theme = useTheme() as ThemeOption;
	return (
		<Box
			width={"90%"}
			component={"input"}
			color={theme?.colorSchemes?.[mode]?.textMain}
			fontSize={"15px"}
			fontFamily={"Montserrat"}
			fontWeight={"600"}
			ref={refInput}
			sx={{
				outline: "none",
				fontWeight: "inherit",
				backgroundColor: "inherit",
				border: "none",
				cursor: "pointer",
				"&:focus": {
					backgroundColor: "inherit",
					borderBottom: "1px solid #ccc",
				},
				"&:hover": {
					cursor: "text",
				},
			}}
			type="text"
			value={valueTitle}
			spellCheck="false"
			onClick={selectAllInlineText}
			onChange={handleGalleryTitleChange}
			onBlur={handleGalleryTitleBlur}
			onKeyDown={(
				e: React.KeyboardEvent<HTMLInputElement> &
					React.FocusEvent<HTMLInputElement>,
			) => e.key === "Enter" && e.target.blur()}
			onMouseDown={(e: React.MouseEvent<HTMLInputElement>) =>
				e.preventDefault()
			}
		/>
	);
};

export default InputUpdate;
